<script>
    import Matches from './matchview/Matches.svelte';
    import Creditcards from './matchview/Creditcards.svelte';
    import Loyaltycards from './matchview/Loyaltycards.svelte';
    import MatchEdges from './matchview/MatchEdges.svelte';

    // --- Properties
    export let dataKey;
    let width, height;
</script>

<div class="row card" bind:clientWidth={width} bind:clientHeight={height}>
    <MatchEdges {dataKey} {width} {height} />
    <Creditcards {dataKey} />
    <Matches {dataKey} />
    <Loyaltycards {dataKey} />
</div>
